export const handleKeyPress = (
	event: React.KeyboardEvent,
	callback: () => void,
) => {
	event.key === 'Enter' && callback();
};
